(() => {
  const init = (section) => {
    if (!section || section.dataset.ezcInitialized === 'true') return;
    section.dataset.ezcInitialized = 'true';

    const form = section.querySelector('.ezc-catalog');
    const drawer = section.querySelector('[data-ezc-filters]');
    const overlay = section.querySelector('[data-ezc-filter-overlay]');
    const openButton = section.querySelector('[data-ezc-filter-open]');
    const closeButton = section.querySelector('[data-ezc-filter-close]');
    const sort = section.querySelector('[data-ezc-sort]');
    const productGrid = section.querySelector('[data-ezc-product-grid]');

    const setDrawer = (open) => {
      if (!drawer || !overlay) return;
      drawer.classList.toggle('is-open', open);
      overlay.classList.toggle('is-open', open);
      document.body.classList.toggle('ezc-filters-open', open);
      openButton?.setAttribute('aria-expanded', String(open));
    };

    openButton?.addEventListener('click', () => setDrawer(true));
    closeButton?.addEventListener('click', () => setDrawer(false));
    overlay?.addEventListener('click', () => setDrawer(false));

    section.querySelectorAll('[data-ezc-filter-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const panel = button.parentElement?.querySelector('[data-ezc-filter-panel]');
        if (!panel) return;
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        panel.hidden = expanded;
        const symbol = button.lastElementChild;
        if (symbol) symbol.textContent = expanded ? '+' : '−';
      });
    });

    sort?.addEventListener('change', () => {
      form?.requestSubmit();
    });

    section.querySelectorAll('[data-ezc-grid]').forEach((button) => {
      button.addEventListener('click', () => {
        section.querySelectorAll('[data-ezc-grid]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
        if (!productGrid) return;
        productGrid.classList.toggle('is-two-columns', button.dataset.ezcGrid === '2');
      });
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 780) setDrawer(false);
    }, { passive: true });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setDrawer(false);
    });
  };

  const initAll = (root = document) => {
    root.querySelectorAll('.ezc-collection').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
